import styled from 'styled-components';

export const Container = styled.div`
  margin-top: ${props => props.theme.spacing.lg};
  padding-top: ${props => props.theme.spacing.sm};
`;

export const InputSelect = styled.select`
  background: ${props => props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.md};
  resize: none;
  outline: none;
  display: block;
  width: 100%;
  height: 36px;
  padding-right: ${props => props.theme.spacing.lg};
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }
`;

export const InputText = styled.input`
  background: ${props =>
    props.disabled ? props.theme.colors.grayLight : props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.md};
  resize: none;
  outline: none;
  display: block;
  width: 100%;
  height: 36px;
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }
`;

export const InputArea = styled.input`
  background: ${props => props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  box-sizing: border-box;
  border-radius: ${props => props.theme.radii.md};
  padding: ${props => props.theme.spacing.sm}
    ${props => props.theme.spacing.md};
  width: 100%;
  min-height: 40px;
  resize: none;
  outline: none;
  color: ${props => props.theme.colors.textPrimary};
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }
`;

export const DeleteButtonContainer = styled.div`
  align-items: center;
`;
